import React, {
    useState,
    useEffect
} from 'react';
import { useNavigate } from 'react-router';

export default function BackButton({ fallback = '/whats-on', className = "", children = 'Back' }) {
    const navigate = useNavigate();
    const [canGoBack, setCanGoBack] = useState(false);
  
    useEffect(() => {
        const previous = sessionStorage.getItem('previousLocation');
        const current = sessionStorage.getItem('currentLocation');
    
        // We can go back if there's a different previous route OR the history stack is deep
        const hasSessionBack = previous && previous !== current;
        const hasHistory = window.history.length > 1;
    
        setCanGoBack(hasSessionBack || hasHistory);
    }, []);

    const handleClick = () => {
        // Use navigate(-1) for history back; if not, use fallback
        if (canGoBack) {
            navigate(-1);
        } else {
            navigate(fallback);
        }
    };

    return (
    <button className={`btn btn--back ${className}`} type="button" role="link" onClick={handleClick}>
      {children}
    </button>
  );
}
